/*
 * Ticket: WCS-33134
 * Esta funcion devolverá el servicio de ringpool según la url.
 * Muy parecido a la función DELIO.Mapfre.newFuncionality.getRPService().
 * Se podrían unificar.
*/
export function getRingPoolService() {
    var urlCompleta = new URL(window.location.href);

    // const dayOfTheWeek = new Date().getDay();

    var service = "3F0501CBA4596C66370F0E5919614308";

    // if (dayOfTheWeek == 6) {
    //     if (window.site == "coche" || window.site == "moto") service = "17086A095B551C891B113056132B1803";
    //     if (window.site == "hogar") service = "17086A095B551C891B113056132B1803";
    // }

    var servicesAll = [
        "https://www.mapfre.es/particulares/seguros-de-vida/confianza-vida-single/",
        "https://www.mapfre.es/ahorro-inversion/ahorro/seguros-pias/",
        "https://www.mapfre.es/ahorro-inversion/planes-de-pensiones/",
        "https://www.mapfre.es/ahorro-inversion/inversion/quiero-empezar-a-invertir/",
        "https://www.mapfre.es/ahorro-inversion/ahorro/seguros-pias/",
        "https://www.mapfre.es/ahorro-inversion/ahorro/seguros-de-rentas/futuro-vitalicio/",
        "https://www.mapfre.es/ahorro-inversion/inversion/asesoramiento-financiero/",
        "https://www.mapfre.es/particulares/seguros-de-vida/",
        "https://www.mapfre.es/particulares/seguros-de-vida/seguro-amortizacion-hipoteca/"
    ];

    var valorEncontrado = servicesAll.find((element => {
        return element === urlCompleta.origin + urlCompleta.pathname
    }));

    // window.servicioCampaign = service;
    return valorEncontrado ? service : false;

}


// WEBPACK FOOTER //
// ./js/function/getRingPoolService.js